import DropDown from "./components/Dropdown.vue";
import TbSelect from "@/components/templates/common/TbSelect";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component("TbSelect", TbSelect);
  }
};

export default GlobalComponents;
